/** PM Drafts — localStorage draft persistence and server draft helpers. */

// Local draft persistence — survives page refresh
const DRAFT_STORAGE_KEY = 'pm_drafts';

window.draftStorage = {
  // Empty string sentinel means "user cleared the draft" vs key missing means "no local data"
  save(threadId, text) {
    if (!threadId) return;
    if (window.viewOnceComposer?.enabled) text = "";
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      drafts[threadId] = text || '';
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(drafts));
    } catch { /* quota exceeded or private browsing */ }
  },
  load(threadId) {
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      return threadId in drafts ? drafts[threadId] : null;
    } catch { return null; }
  },
  remove(threadId) {
    if (!threadId) return;
    try {
      const drafts = JSON.parse(localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
      delete drafts[threadId];
      localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(drafts));
    } catch { /* ignore */ }
  }
};

// Debounced server-side draft save — fires 2s after user stops typing
var _draftSaveTimer = null;
var _lastSavedDraft = {};
var _draftRequests = {};

function saveDraftToServer() {
  var threadId = window.get_active_thread_id();
  if (!threadId) return;

  var message = window.viewOnceComposer?.enabled ? '' : $.trim($("#message").val()) || '';

  // Skip if unchanged since last server save
  if (_lastSavedDraft[threadId] === message) return;
  _lastSavedDraft[threadId] = message;

  queueDraft(threadId, message);
}

function queueDraft(threadId, message) {
  if (!threadId) return;
  // Each clear follows every earlier save for this thread.
  const previous = _draftRequests[threadId] || Promise.resolve();
  const request = previous.catch(() => {}).then(() => $.ajax({
    type: "POST",
    url: "/app/messages/update",
    data: { thread: threadId, draft: { message } },
    dataType: "json"
  })).then(data => {
    if (data && data.ok === false) throw new Error('draft_save_failed');
  }).catch(() => {
    if (_lastSavedDraft[threadId] === message) delete _lastSavedDraft[threadId];
  });
  _draftRequests[threadId] = request;
  request.then(() => {
    if (_draftRequests[threadId] === request) delete _draftRequests[threadId];
  });
}

$(document).on("input", "#message", function() {
  clearTimeout(_draftSaveTimer);
  _draftSaveTimer = setTimeout(saveDraftToServer, 2000);

  var threadId = window.get_active_thread_id();
  if (threadId) {
    var val = window.viewOnceComposer?.enabled ? '' : $(this).val();
    // Keep in-memory draft cache in sync for thread-view.js
    window.last_draft[threadId] = val;
    // Also persist to localStorage immediately
    window.draftStorage.save(threadId, val);
  }
});

window["auto_save_intvl"] = 60000;
window["DraftAutoSave"] = function() {
  $("#saveDraftBtn").trigger("click");
  window.setTimeout("DraftAutoSave()", window.auto_save_intvl);
};

window.clearPrivateCaptionDraft = function() {
  clearTimeout(_draftSaveTimer);
  const id = window.get_active_thread_id();
  _lastSavedDraft[id] = '';
  queueDraft(id, '');
  window.draftStorage.save(id, "");
  if (id) window.last_draft[id] = "";
};
